import React, { useEffect, useState } from 'react';
import AppModal from '../common/AppModal';
import LinkifiedTextInput from '../common/LinkifiedTextInput';
import { Button, ButtonGroup, FormLabel } from 'react-bootstrap';
import useLocalization from '../../hooks/useLocalization';
import HorizontalProgress from '../common/HorizontalProgress';
import { startCase } from 'lodash';
const AddEditFieldInfo = ({ show, onHide, value, onSave, label, onChange, fieldKey, progress }) => {
  const { translate } = useLocalization();
  const [fieldInfo, setFieldInfo] = useState('');
  const [initialValue, setInitialValue] = useState('');
  const [initialFieldKey, setInitialFieldKey] = useState('');

  const handleChange = value => {
    setFieldInfo(value);
  };

  const internalOnhide = () => {
    setFieldInfo('');
    onHide();
  };

  const internalOnSave = () => {
    onChange(fieldInfo);
    onSave(fieldInfo);
  };

  useEffect(() => {
    setFieldInfo(value);
  }, [value]);

  useEffect(() => {
    if (initialFieldKey === fieldKey) return;
    setInitialValue(value);
    setInitialFieldKey(fieldKey);
  }, [value, fieldKey]);

  return (
    <AppModal
      modalBodyClassName="p-3"
      show={show}
      onHide={internalOnhide}
      title={`${startCase(label)}`}
      titleClassName="truncate-modal-title"
    >
      <LinkifiedTextInput
        rows={3}
        placeholder={translate('add_your_notes_here')}
        value={fieldInfo}
        onChange={handleChange}
      />
      {progress && <HorizontalProgress />}
      <div className="d-flex justify-content-between mt-4">
        <Button
          disabled={progress || !fieldInfo}
          size="sm"
          className="m-0"
          variant="outline-dark"
          onClick={() => {
            setFieldInfo('');
            onChange('');
            initialValue && onSave('');
          }}
        >
          {translate('clear_notes')}
        </Button>
        <Button disabled={progress} size="sm" variant="primary text-white" onClick={internalOnSave}>
          {translate('save')}
        </Button>
      </div>
    </AppModal>
  );
};

export default AddEditFieldInfo;
